module.exports = __webpack_public_path__ + "img/liz.2f805c80.svg";